import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useIsFetching } from '@tanstack/react-query';
import { useFirebaseAuth, UserContext } from '../services/firebase';
import Drift from './Drift';
import PrimaryNavigation from './PrimaryNavigation';
import DataLoading from './DataLoading';
import { cn } from "cn";

const Layout: React.FC<any> = (props) => {
    const { signOut } = useFirebaseAuth();
    const user = useContext(UserContext);
    const refetchingCount = useIsFetching({
        predicate: (query) => query.state.data !== undefined && query.state.fetchStatus === 'fetching',
    });

    return (
        <section
            className={cn(
                'flex min-h-screen flex-col',
                props.gray && 'bg-gray-100'
            )}
        >
            <nav className="flex h-20 w-full items-center justify-between border-b border-gray-300 bg-cyan-200 p-4">
                <Link to="/">
                    <img
                        src="/logo.svg"
                        alt="Grail Talent"
                        className="h-12 w-auto"
                    />
                </Link>
                {/* Row of header actions: refetch spinner immediately left of the menu button. */}
                <div className="flex items-center gap-2">
                    {refetchingCount > 0 && <DataLoading />}
                    <PrimaryNavigation signOut={signOut} user={user} />
                </div>
            </nav>

            <main className="min-h-[calc(100vh-10rem)]">{props.children}</main>

            {user?.id &&
                !user?.roles?.manager &&
                !user.roles?.admin &&
                !user.roles?.creator ? (
                <Drift
                    appId="gdkdrsrydzrd"
                    userId={user.id}
                    attributes={{
                        email: user.email,
                        company: user.company,
                        phone_number: user.phone,
                        first_name: user.firstName,
                        last_name: user.lastName,
                    }}
                />
            ) : null}

            <footer className="flex h-20 w-full items-center justify-between bg-black p-4 text-white">
                <div className="text-tiny/4">
                    v{import.meta.env.VITE_APP_VERSION}
                </div>
                <div>&copy; Grail Talent</div>
                <div>
                    <a
                        href="https://grail-talent.com/terms"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Terms
                    </a>
                </div>
            </footer>
        </section>
    );
};

export default Layout;
